import { render, staticRenderFns } from "./SetServicesList.vue?vue&type=template&id=513825ad&scoped=true&"
import script from "./SetServicesList.vue?vue&type=script&lang=js&"
export * from "./SetServicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513825ad",
  null
  
)

export default component.exports